import InputField from '../inputFieldClass'
export default class Name extends InputField {

} 
